import { Link } from "react-router-dom";
import { useCText } from "../lib/cms";
import { useI18n } from "../lib/i18n";
import { useSEO } from "../lib/seo";
import RichText from "../components/RichText";

export default function Shipping() {
  const { lang } = useI18n();
  const title = useCText("shipping.title", "shipping.title");
  const body = useCText("shipping.body", "shipping.body");
  useSEO({ title: lang === "en" ? "Shipping · Maggie Records" : "Envíos · Maggie Records" });

  return (
    <div className="max-w-[860px] mx-auto px-5 md:px-10 pt-10 md:pt-14" data-testid="shipping-page">
      <p className="text-xs text-muted-foreground mb-2">{lang === "en" ? "Legal" : "Información legal"}</p>
      <h1 className="text-2xl md:text-4xl font-medium leading-tight mb-8">{title}</h1>
      <RichText text={body} className="text-sm md:text-base leading-relaxed text-foreground/90" />
      <div className="mt-12 pt-6 border-t border-border text-sm flex flex-wrap gap-6">
        <Link to="/catalogo" className="vmr-link-underline">{lang === "en" ? "Browse the catalogue →" : "Ver el catálogo →"}</Link>
        <Link to="/contacto" className="vmr-link-underline">{lang === "en" ? "Questions? Contact us" : "¿Dudas? Escríbenos"}</Link>
      </div>
    </div>
  );
}
